import React from 'react';
import PropTypes from 'prop-types';

import { addLabels } from '../Util/label';
import { toPercent, humanizeNumber } from '../../../utils/format';
import DataTable from './DataTable/DataTable';
import { ESRI_YEAR_DEFAULTS } from '../../../constants';

const PopulationTables = ({
  overview: { population, industry, housing, labor, race },
}) => (
  <div>
    <div className="property-images" />
    <section>
      <DataTable
        sectionTitle="Population Overview"
        data={[
          {
            label: `Population ${ESRI_YEAR_DEFAULTS.currentYear}`,
            value: humanizeNumber(population.populationCurrent),
          }, {
            label: `Population ${ESRI_YEAR_DEFAULTS.projectedYear}`,
            value: humanizeNumber(population.populationProjection),
          }, {
            label: `Female Population ${ESRI_YEAR_DEFAULTS.currentYear}`,
            value: humanizeNumber(population.femalePopulationCurrent),
          }, {
            label: `Male Population ${ESRI_YEAR_DEFAULTS.currentYear}`,
            value: humanizeNumber(population.malePopulationCurrent),
          }, {
            label: 'Diversity Index',
            value: population.diversityIndex,
          },
        ]}
      />
    </section>
    <section>
      <DataTable
        sectionTitle="Population By Race"
        data={addLabels(race).map(([label, pop]) => ({
          label,
          value: toPercent(pop, population.populationCurrent),
        }))}
      />
      <DataTable
        sectionTitle="Housing Overview"
        data={[
          {
            label: `${ESRI_YEAR_DEFAULTS.currentYear} Median Home Value`,
            value: `$${humanizeNumber(housing.homeValueCurrent)}`,
          }, {
            label: `${ESRI_YEAR_DEFAULTS.projectedYear} Median Home Value`,
            value: `$${humanizeNumber(housing.homeValueProjection)}`,
          }, {
            label: `${ESRI_YEAR_DEFAULTS.currentYear} Total Housing Units`,
            value: humanizeNumber(housing.totalUnitsCurrent),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.currentYear} Owner Occupied Units`,
            value: humanizeNumber(housing.ownedUnitsCurrent),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.currentYear} Renter Occupied Units`,
            value: humanizeNumber(housing.rentedUnitsCurrent),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.currentYear} Vacant Units`,
            value: humanizeNumber(housing.vacantUnitsCurrent),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.projectedYear} Total Housing Units`,
            value: humanizeNumber(housing.totalUnitsProjection),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.projectedYear} Owner Occupied Units`,
            value: humanizeNumber(housing.ownedUnitsProjection),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.projectedYear} Renter Occupied Units`,
            value: humanizeNumber(housing.rentedUnitsProjection),
          }, {
            label: `${ESRI_YEAR_DEFAULTS.projectedYear} Vacant Units`,
            value: humanizeNumber(housing.vacantUnitsProjection),
          },
        ]}
      />
      <DataTable
        sectionTitle="Workforce"
        data={[
          {
            label: 'Total Workforce',
            value: humanizeNumber(labor.laborForce),
          }, {
            label: 'Employed',
            value: toPercent(labor.laborForceEmployed, labor.laborForce),
          }, {
            label: 'Unemployed',
            value: toPercent(labor.laborForceUnemployed, labor.laborForce),
          },
        ]}
      />
      <DataTable
        sectionTitle="Employment by Industry"
        data={addLabels(industry).map(([label, pop]) => ({
          label: label.replace(/\//g, ' / '),
          value: humanizeNumber(pop),
        }))}
      />
    </section>
  </div>
);

PopulationTables.propTypes = {
  overview: PropTypes.object,
};

export default PopulationTables;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/PopulationTables.js